import { render } from "./DealRecord.vue?vue&type=template&id=cf5eb63a"
import script from "./DealRecord.vue?vue&type=script&lang=js"
export * from "./DealRecord.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__